import { paginatedTransform, rawTransform } from 'src/services/skuit/utils'
import { BarcodedUnit, PaginatedResponse } from '../../api/models'

import { API, CustomAxiosConfig } from './types'
import { ExportFilters } from '../skuit/types'

import fileDownload from 'js-file-download'

export interface ExportProps {
  fields: string[],
  exportFilters?: ExportFilters
}

export class BarcodedUnits {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<BarcodedUnit>> => {
    const response = await this.api.get('/logistics/barcoded-units', config)
    return paginatedTransform(BarcodedUnit)(response.data)
  }

  retrieve = async (guid: string, config: CustomAxiosConfig = {}): Promise<BarcodedUnit> => {
    const response = await this.api.get(`/logistics/barcoded-units/${guid}`, config)
    return rawTransform(BarcodedUnit)(response.data)
  }

  export = async ({ fields, exportFilters}: ExportProps) => {
    const guid: string | undefined = exportFilters?.guid
    const params = { fields: fields.join(','), products: guid }
    const response = await this.api.axiosInstance({
      url: 'logistics/barcoded-units/export',
      params,
      responseType: 'blob'
    })
    fileDownload(response.data, (guid ? `barcodedUnits_product_${guid}.csv` : 'barcodedUnits.csv'))
  }
}
